import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-dashboard",
  "use": "icon-dashboard-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dashboard\"><path d=\"M128 554.666667h341.333333V128H128v426.666667z m0 341.333333h341.333333v-256H128v256z m426.666667 0h341.333333V469.333333h-341.333333v426.666667z m0-768v256h341.333333V128h-341.333333z\" p-id=\"23890\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol